import { UseFiltersColumnOptions, UseGlobalFiltersOptions } from "react-table";
import { TableRow } from "./types";

function textIncludes(value: string, filterValue: string) {
  return value.toLowerCase().includes(filterValue.toLowerCase());
}

export const linkFilter: UseFiltersColumnOptions<TableRow>["filter"] = (
  rows,
  columnIds,
  filterValue
) => {
  return rows.filter((row) => {
    let value = row.values[columnIds[0] as string] as TableRow[string];
    if (value && typeof value === "object") {
      value = value.text;
    }
    return typeof value === "string" ? textIncludes(value, filterValue) : false;
  });
};

export const globalFilter: UseGlobalFiltersOptions<TableRow>["globalFilter"] = (
  rows,
  columnIds,
  filterValue
) => {
  return rows.filter((row) => {
    return Object.entries(row.values).some(([key, value]) => {
      if (!columnIds.includes(key)) {
        return false;
      }

      if (value && typeof value === "object") {
        return textIncludes(value.text, filterValue);
      }

      return textIncludes(String(value), filterValue);
    });
  });
};
